import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { encriptar } from "../utilities/encriptacion";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const useGetDataUser = () => {
    const [info, setInfo] = useState()

    useEffect(() => {
        try {
            const token = sessionStorage.getItem('token')
            const decript = jwtDecode(token)
            setInfo(decript)
        }
        catch(error) {
            console.log("no esxiste el token",error);
            
        }
    }, [])
    return info

}
export default useGetDataUser